import { render, staticRenderFns } from "./dialogMetadata.vue?vue&type=template&id=a2bb02e4"
import script from "./dialogMetadata.vue?vue&type=script&lang=js"
export * from "./dialogMetadata.vue?vue&type=script&lang=js"
import style0 from "./dialogMetadata.vue?vue&type=style&index=0&id=a2bb02e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports